import { NetworkStatus } from '@apollo/client';
import { useCallback } from 'react';
import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';
import { useHannibalQuery } from '../../common/schema/hannibal/HannibalContext';
import { FreeTextSearchDocument } from '../../common/schema/hannibal/types.generated';
import { useVariables } from './useVariables';

export const useSearchQuery = (
  filterChoice: FilterChoice,
  perPage?: number,
  skip?: boolean,
  searchRadius?: number,
) => {
  const variables = useVariables(filterChoice, perPage, searchRadius);

  const { loading, error, data, fetchMore, networkStatus } = useHannibalQuery(
    FreeTextSearchDocument,
    {
      variables,
      skip,
    },
  );

  const fetchingMore = networkStatus === NetworkStatus.fetchMore;

  const endCursor = data?.searchProfiles.pageInfo.endCursor;

  const performFetchMore = useCallback(
    () =>
      fetchMore({
        variables: {
          after: endCursor,
        },
        updateQuery: (prevData, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevData;

          return {
            ...prevData,
            searchProfiles: {
              ...fetchMoreResult.searchProfiles,
              results: [
                ...(prevData.searchProfiles.results ?? []),
                ...(fetchMoreResult.searchProfiles.results ?? []),
              ],
            },
          };
        },
      }),
    [endCursor, fetchMore],
  );

  return {
    loading,
    error,
    data,
    fetchMore: performFetchMore,
    fetchingMore,
  };
};
